import React, { useEffect, useState } from 'react';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// react components for routing our app without refresh
import { Link, useHistory, useParams } from "react-router-dom";

import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import headersStyle from "assets/jss/trip-kit/views/sectionsSections/headersStyle.js";
import basicsStyle from "assets/jss/trip-kit/views/componentsSections/basicsStyle.js";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";

const useStyles = makeStyles(headersStyle);
const useStyles2 = makeStyles(basicsStyle);

const MainSearch = (props) => {
    const [cities, setCities] = useState("");
    const [citiesValue, setCitiesValue] = useState("");
    const [districe, setDistrice] = useState("");
    const [districeValue, setDistriceValue] = useState("");
    const [kwd, setKwd] = useState("");
    const classes = useStyles();
    const classes2 = useStyles2();
    let { keyword } = useParams("");
    let { city } = useParams("");
    let { district } = useParams("");

    const handleCities = event => {
     
        setCitiesValue(event.target.value);
        if(event.target.value !="0" && event.target.value ){
            setDistriceValue("");
            props.visitkorea
            .areaCode(event.target.value, "50","1")
            .then(function (response) {
                setDistrice(response);
            });
        } else {
            setDistriceValue("");
            setDistrice("");
        }
      };
    const handleDistrice = event => {
        if(event.target.value){
            setDistriceValue(event.target.value);
        }
    
    };
    const onKeyUp=()=>{
        const pattern = /[\[\]\{\}\&\$]/gi;
        setKwd(document.getElementById("mainSearch").value.replace(pattern,""));
    }
    const history = useHistory();
    const handleKeyPress = (e) => {
        if (e.key == "Enter") {
            document.activeElement.blur();
            history.push(`/search/${kwd ? kwd : "no"}/${citiesValue ? citiesValue : "0"}/${districeValue ? districeValue : "0"}`);
        }
    };
    useEffect(() => {
   
        if(city=="" || city==undefined){
            props.visitkorea
            .areaCode("", "50","1")
            .then(function (response) {
                setCities(response);
            });
        } else {
            props.visitkorea
            .areaCode("", "50","1")
            .then(function (response) {
                setCities(response);
                setCitiesValue(city);
            });
            if(district && city !="0"){
                props.visitkorea
                .areaCode(city, "50","1")
                .then(function (response) {
                    setDistrice(response);
                    setDistriceValue(district);
                });
            }else {
                setDistriceValue(0);
            }
        }

        if (keyword && keyword !="no") {
            document.getElementById("mainSearch").value = keyword; 
            setKwd(keyword);
        }
    },[props.visitkorea, keyword,city,district]);

    return (
        <>
        <GridContainer justify="center">
            <GridItem xs={props.xs1} sm={4} md={4}>
                <FormControl fullWidth className={classes2.selectFormControl}>
                <InputLabel htmlFor="simple-select" className={classes2.selectLabel}>{i18n.t('searchCities')}</InputLabel>
                <Select  MenuProps={{ className: classes2.selectMenu }} classes={{select: classes2.select }} value={citiesValue} onChange={handleCities} inputProps={{name: "cities", id: "cities"}}>
                    <MenuItem disabled classes={{  root: classes2.selectMenuItem }}>{i18n.t('searchCities')}</MenuItem>
                    <MenuItem classes={{ root: classes2.selectMenuItem, selected: classes2.selectMenuItemSelected}}  value="0" >{i18n.t('searchAllCities')}</MenuItem>
                    {
                        cities ?
                            cities.map((city => (  <MenuItem key={city.code} classes={{ root: classes2.selectMenuItem, selected: classes2.selectMenuItemSelected}}  value={city.code}  >{city.name}</MenuItem> )))  
                        :
                            ""
                    }
                   
                </Select>
                </FormControl>
            </GridItem>
            <GridItem xs={props.xs1} sm={4} md={4}>
                <FormControl fullWidth className={classes2.selectFormControl}>
                <InputLabel htmlFor="simple-select" className={classes2.selectLabel}>{i18n.t('searchDistrice')}</InputLabel>
                <Select  MenuProps={{ className: classes2.selectMenu }} classes={{select: classes2.select }} value={districeValue} onChange={handleDistrice} inputProps={{name: "districe", id: "districe"}}>
                    <MenuItem disabled classes={{  root: classes2.selectMenuItem }}>{i18n.t('searchDistrice')}</MenuItem>
                    <MenuItem classes={{ root: classes2.selectMenuItem, selected: classes2.selectMenuItemSelected}}  value="0" >{i18n.t('searchAllDistrice')}</MenuItem>
                    {
                        districe.length >1 ?
                            districe.map((district => (  <MenuItem key={district.code} classes={{ root: classes2.selectMenuItem, selected: classes2.selectMenuItemSelected}}  value={district.code}  >{district.name} </MenuItem> )))  
                        :
                        <MenuItem key={districe.code} classes={{ root: classes2.selectMenuItem, selected: classes2.selectMenuItemSelected}}  value={districe.code}  >{districe.name} </MenuItem>
                    }
                   
                </Select>
                </FormControl>
            </GridItem>
        </GridContainer>
        <GridContainer justify="center">
            <GridItem xs={props.xs2} sm={6} md={6} >
                <CustomInput id="mainSearch" onKeyUp={onKeyUp} onKeyPress={handleKeyPress}
                inputProps={{ placeholder: i18n.t('mainSearch'),name:"main_search",startAdornment: (<Search className={classes.searchIcon} />) }}
                formControlProps={{ fullWidth: true }}
                />
            </GridItem>
            <GridItem xs={props.xs2} sm={2} md={2}>
                <Link to={`/search/${kwd ? kwd : "no"}/${citiesValue ? citiesValue : "0"}/${districeValue ? districeValue : "0"}`}>
                    <Button  block color="primary" className={classes.button} >{i18n.t('search')}</Button>
                </Link>
            </GridItem>
        </GridContainer>
        </>
    );
};

export default withTranslation()(MainSearch);